import {AppBox, AppButton, AppPaper, AppText, AppTitle} from "../../../../../commons/components";
import AppBorderBox from "../../../../../commons/components/BorderBox";
import IconEmpty from "../../../../../commons/components/icons/empty";
import {SeasonStatusEnum} from "../../../../../commons/enums/season-status-enum";
import {IFootballCompetition, IFootballHostedCompetition,} from "../../../../../commons/models/football/interface/i-football-competition";
import ability from "../../../../../casl/Can";
import {RolePolicyActionEnum} from "../../../../../commons/enums/role-policy-action.enum";
import {ManageFootballTeam} from "../../../../../commons/models/football/admin/manage-football-team";
import {ManageFootballCompetition} from "../../../../../commons/models/football/admin/manage-football-competition";

interface EmptyBracketComponentProps {
    competition: IFootballCompetition | IFootballHostedCompetition;
    isPastSeason?: boolean;
    onCreateClick?: () => void;
}

export const EmptyBracketComponent = ({onCreateClick, competition, isPastSeason}: EmptyBracketComponentProps) => {
    return (
        <AppPaper shadow="xs">
            <AppBorderBox borderVariant="dashed" p="sm">
                <AppBox alignItems="center" flexDirection="column" justifyContent="center" gap="2xs">
                    <IconEmpty width={56} height={56} color="rgba(var(--border-200))"/>
                    <AppTitle as="h6">No bracket created</AppTitle>
                    {(ability.can(
                            RolePolicyActionEnum.UPDATE,
                            new ManageFootballTeam((competition as IFootballHostedCompetition).hostTeam)
                        ) ||
                        ability.can(RolePolicyActionEnum.UPDATE, competition as ManageFootballCompetition)) && (
                        <>
                            {competition.latestSeason && competition.latestSeason.status === SeasonStatusEnum.Active ? (
                                <AppText fontWeight="semibold">You need to create a bracket to continue ahead.</AppText>
                            ) : (
                                <AppText fontWeight="semibold">
                                    To create bracket, you need to start the season first. Click the "Start Season"
                                    button above to begin.
                                </AppText>
                            )}
                            <AppBox displayBlock mt={"xs"}>
                                <AppButton
                                    label="Create A Bracket"
                                    onClick={onCreateClick}
                                    disabled={!(competition.latestSeason && competition.latestSeason.status === SeasonStatusEnum.Active)}
                                />
                            </AppBox>
                        </>
                    )}
                </AppBox>
            </AppBorderBox>
        </AppPaper>
    );
};
